import React, { Component } from 'react'
import Line from '../Line'
import { translation } from '../../../../utils/helpers'

import './assesmentforsiline.scss'

class AssesmentForsiLine extends Component {

  renderLine () {
    let notation = ''
    let line = this.props.line
    let reportType = this.props.reportType
    let currencyCode = this.props.currencyCode
    let useSubline = true // reportType === 2 // ForsiManual // RPreport
    let className = reportType === 2 ? 'forsi-RPreport__line' : 'forsi-body__line'
    let amount
    if (line.ManualPrice && this.props.showPrices) { amount = line.ManualPrice; notation = translation(currencyCode) }
    if (line.CalculatedPrice && this.props.showPrices) { amount = line.CalculatedPrice; notation = translation(currencyCode) }
    if (line.UnitPrice && this.props.showAE) { amount = line.UnitPrice }
    if (line.WorkUnits && this.props.showAE) { amount = line.WorkUnits; notation = translation('885') }
    if (line.GenericValue) { amount = line.GenericValue }
    const lineText = line.LineText ? line.LineText.split('\r\n') : []

    if (lineText.length > 1) {
      const first = lineText[0]
      const last = lineText.slice(-1)
      const rest = lineText.filter((n, i) => i !== 0 && i !== lineText.length - 1)
      return (
        <Line boldText text={first}>
          {rest.map((n, key) => <Line text={n} className={className} subLine={useSubline} key={key} />)}
          <Line text={last} amount={amount} noFormat currencyType={notation} className={className} subLine={useSubline} />
        </Line>
      )
    } else {
      let format = 'noFormat'
      // format the amount if it is a decimal number
      if (amount % 1 !== 0 && amount !== 'undefined' && line.LineType === 1) { format = '' }

      // method // LineType: 0 = Generic
      if (line.LineType === 0 && !line.GenericValue && line.LineNumber) {
        return (
          <div className='extent-line clearfix'>
            <span className='bold'>{line.LineNumber} </span>
            <span>{line.LineText}</span>
          </div>
        )
      }
      return (
        <div>
          {line.AdditionalText ? (
            <Line bold text={line.LineText}>
              <Line text={line.AdditionalText} amount={amount} noFormat currencyType={notation} subLine />
            </Line>
          ) : (
            <Line boldText boldAmount={this.props.boldAmount} text={line.LineText} noFormat={format} amount={amount} currencyType={notation} />
            )}
        </div>
      )
    }
  }

  render () {
    if (this.props.line) return this.renderLine()
    return null
  }
}

export default AssesmentForsiLine



// WEBPACK FOOTER //
// ./src/app/shared/components/Extent/AssesmentForsiLine/index.js